import api from '@/lib/api';

const state = {
    profile: null,
    status: 'loading',
};

const getters = {
    isProfileLoaded: (state) => state.status === 'success',
    isVerified: (state) => !!state.profile.verified_at,
};

const actions = {
    userRequest: ({ commit }) => {
        commit('userRequest');

        const request = api.v1.profile.show();
        request
            .then((resp) => {
                commit('userSuccess', resp.data.data);
            })
            .catch(() => {
                commit('userError');
            });

        return request;
    },
    // The inverse of userRequest, but no actual web request
    removeUser: ({ commit }) => {
        commit('userRemove');
        return Promise.resolve();
    },
};

const mutations = {
    userRequest: (state) => {
        state.status = 'loading';
    },
    userSuccess: (state, resp) => {
        state.status = 'success';
        state.profile = resp;
    },
    userError: (state) => {
        state.status = 'error';
    },
    userRemove: (state) => {
        state.status = 'loading';
        state.profile = null;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
